import './styles/base.css';

const mountElement = document.querySelector<HTMLDivElement>('#app');

if (!mountElement) {
  throw new Error('Missing #app mount point');
}
const mount: HTMLDivElement = mountElement;

mount.innerHTML = `
  <main class="boot-shell" aria-label="Lumenweave loading">
    <div class="boot-mark" aria-hidden="true">
      <span></span><span></span><span></span>
    </div>
    <p>Aligning the Lumenweave…</p>
  </main>
`;

async function boot(): Promise<void> {
  if (new URLSearchParams(location.search).get('gallery') === 'art') {
    const { mountArtGallery } = await import('./dev/ArtGalleryApp');
    mountArtGallery(mount);
    return;
  }

  const [{ LumenweaveAudio }, { LumenweaveApplication }] = await Promise.all([
    import('./audio'),
    import('./app/LumenweaveApplication'),
  ]);
  const application = new LumenweaveApplication({
    mount,
    audio: new LumenweaveAudio(),
  });
  Object.assign(window, { __lumenweaveApp: application });
  window.addEventListener(
    'beforeunload',
    () => {
      void application.dispose();
    },
    { once: true },
  );
}

void boot().catch((error: unknown) => {
  console.error('Lumenweave failed to start', error);
  mount.innerHTML = `
    <main class="boot-shell boot-shell--error" role="alert">
      <img src="/lumenweave-mark.svg" alt="" width="96" height="96" />
      <h1>The Skyloom paused</h1>
      <p>Reload to realign the weave. Your saved journey is safe.</p>
      <button type="button" onclick="location.reload()">Reload Lumenweave</button>
    </main>
  `;
});
